import { FC, useEffect } from 'react';
import { Select, Tooltip, HStack, Icon, useColorModeValue } from '@chakra-ui/react';
import { IoMdBusiness } from 'react-icons/io';
import { useTranslation } from 'react-i18next';
import { useFunnelContext, useFunnels } from '@bemap/crm-microfrontends';
import { getFunnels, SalesFunnel as SalesFunnelType } from '@/services/crm-service';

export const FunnelSelector: FC = () => {
  const { t } = useTranslation();
  const navbarIcon = useColorModeValue('gray.400', 'white');
  const { selectedFunnelId, setSelectedFunnelId, setFunnels } = useFunnelContext();

  const fetchFunnels = async () => {
    const res = await getFunnels();
    return (res.message || []) as SalesFunnelType[];
  };

  const { funnels, loading } = useFunnels(fetchFunnels);

  useEffect(() => {
    if (funnels.length > 0) {
      setFunnels(funnels);
      // If no funnel is selected, select the default or first one
      if (!selectedFunnelId) {
        const defaultFunnel = funnels.find(f => f.is_default) || funnels[0];
        if (defaultFunnel) {
          setSelectedFunnelId(defaultFunnel.id);
        }
      }
    }
  }, [funnels, selectedFunnelId, setFunnels, setSelectedFunnelId]);

  if (loading || funnels.length === 0) {
    return null;
  }

  return (
    <Tooltip label={t('crm.select_funnel') || 'Select Funnel'}>
      <HStack spacing={2}>
        <Icon as={IoMdBusiness} h="18px" w="18px" color={navbarIcon} />
        <Select
          value={selectedFunnelId || ''}
          onChange={(e) => setSelectedFunnelId(Number(e.target.value))}
          maxW="200px"
          size="sm"
          variant="unstyled"
          color={navbarIcon}
        >
          {funnels.map((funnel) => (
            <option key={funnel.id} value={funnel.id}>
              {funnel.name}
            </option>
          ))}
        </Select>
      </HStack>
    </Tooltip>
  );
};

